export default "__VITE_ASSET__SCV$QsTQ__"